// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Images/Login Background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
    width: 100%;
    margin: 0%;
    padding: 0%;
}

.wrapper-Login {
    display: flex;
    height: calc(100vh - 59px);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.container-Login {
    position: relative;
    bottom: 10%;
    width: 80%;
    max-width: 420px;
    border: 1px solid grey;
    height: auto;
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    padding-bottom: 25px;
    border: none;
    border-radius: 6px;
    background-color: white;
}

.input-email {
    width: 80%;
    padding: 16px;
    border: 1px solid grey;
    display: block;
    outline: none;
    border-radius: 4px;
    margin-top: 22px;
    margin-bottom: 22px;
    font-size: 16px;
    margin-left: auto;
    margin-right: auto;
}

.input-pass {
    width: 80%;
    padding: 16px;
    border: 1px solid grey;
    display: block;
    outline: none;
    border-radius: 4px;
    margin-bottom: 22px;
    font-size: 16px;
    margin-left: auto;
    margin-right: auto;
}

.button-Login {
    width: 90%;
    padding: 16px;
    border: none;
    display: block;
    outline: none;
    border-radius: 4px;
    font-size: 16px;
    background-color: #477AFE;
    font-weight: 700;
    font-size: 18px;
    color: white;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
}

.button-Login:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.anchor-ForgotLogin {
    text-decoration: none;
    font-size: 18px;
    margin-bottom: 15px;
    margin-left: auto;
    margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,yDAAyD;IACzD,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["form {\n    width: 100%;\n    margin: 0%;\n    padding: 0%;\n}\n\n.wrapper-Login {\n    display: flex;\n    height: calc(100vh - 59px);\n    background-image: url(\"/src/Images/Login Background.jpg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n}\n\n.container-Login {\n    position: relative;\n    bottom: 10%;\n    width: 80%;\n    max-width: 420px;\n    border: 1px solid grey;\n    height: auto;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 16px;\n    padding-bottom: 25px;\n    border: none;\n    border-radius: 6px;\n    background-color: white;\n}\n\n.input-email {\n    width: 80%;\n    padding: 16px;\n    border: 1px solid grey;\n    display: block;\n    outline: none;\n    border-radius: 4px;\n    margin-top: 22px;\n    margin-bottom: 22px;\n    font-size: 16px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.input-pass {\n    width: 80%;\n    padding: 16px;\n    border: 1px solid grey;\n    display: block;\n    outline: none;\n    border-radius: 4px;\n    margin-bottom: 22px;\n    font-size: 16px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.button-Login {\n    width: 90%;\n    padding: 16px;\n    border: none;\n    display: block;\n    outline: none;\n    border-radius: 4px;\n    font-size: 16px;\n    background-color: #477AFE;\n    font-weight: 700;\n    font-size: 18px;\n    color: white;\n    margin-left: auto;\n    margin-right: auto;\n    cursor: pointer;\n}\n\n.button-Login:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.anchor-ForgotLogin {\n    text-decoration: none;\n    font-size: 18px;\n    margin-bottom: 15px;\n    margin-left: auto;\n    margin-right: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
